import { render, staticRenderFns } from "./GoodsGroupModify.vue?vue&type=template&id=029d3f14&scoped=true"
import script from "./GoodsGroupModify.vue?vue&type=script&lang=js"
export * from "./GoodsGroupModify.vue?vue&type=script&lang=js"
import style0 from "./GoodsGroupModify.vue?vue&type=style&index=0&id=029d3f14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029d3f14",
  null
  
)

export default component.exports